import React from 'react';
import { Icon } from 'selfly-ui-react';

import { alarmCategories } from './alarmConfig';

const SummaryPopOver = ({ alertTypes, locations, selectedLocations }) => {
    return (
        <div className="summary">
            <div className="summary__title">Below is your alarm subscription summary.</div>
            <div className="summary__item">
                <label className="summary__label">Locations</label>
                <ul>
                    {selectedLocations &&
                        selectedLocations.map(locationId => {
                            const currentLocation = locations.find(location => location.code === locationId);
                            return (
                                <li key={locationId}>
                                    <Icon>check</Icon>
                                    {currentLocation ? currentLocation.name : ''}
                                </li>
                            );
                        })}
                </ul>
            </div>
            <div className="summary__alerts">
                {alarmCategories.map(category => {
                    return (
                        <div className="summary__alerts-item" key={category.name}>
                            <label className="summary__label">{category.name}</label>
                            <ul>
                                {category.types
                                    .filter(type => {
                                        return alertTypes.find(alert => {
                                            return (
                                                alert.type.toLowerCase() === type.type.toLowerCase() &&
                                                alert.severity.toLowerCase() === type.severity.toLowerCase()
                                            );
                                        });
                                    })
                                    .map(el => {
                                        return (
                                            <li key={el.label}>
                                                <Icon>check</Icon>
                                                {el.label}
                                            </li>
                                        );
                                    })}
                            </ul>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export default SummaryPopOver;
